import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../Buttons/BtnSubmit';
import {isMobile} from 'react-device-detect';
import {reportDWH} from './contactUsSlice';

const ContactUs = (props) => {
  useEffect(() => {
    props.reportDWH({actionType: 'Help Popup', status: 'Ongoing', messageText: 'Help Popup Displayed'});
  }, []);

  const handleWhatsappClick = () => {
    props.reportDWH({actionType: 'Help Popup', status: 'Ongoing', messageText: 'Whatsap Button Clicked'});
  };

  const handleServiceClick = () => {
    props.reportDWH({actionType: 'Help Popup', status: 'Ongoing', messageText: 'Dial Button Clicked'});
  };

  const handleChatClick = () => {
    props.reportDWH({actionType: 'Help Popup', status: 'Ongoing', messageText: 'Chat Button Clicked'});
    try {
      widgetClient.setWidgetVisiblity(true);
    } catch (e) {}
  };

  return (
    <div className='container_popup'>
      <div className='main_title'>מעדיפים לדבר איתנו?</div>
      <div className='secondary_title'>כל הדרכים ליצור איתנו קשר</div>

      <div className='icon_whatsapp'>
        <Image src={require('./images/icon-58-whatsapp@2x.svg')} alt='whatapp' className='icon58whatsapp' />
        <a
          className='context_whatapp'
          href={isMobile ? `whatsapp://send?text=שלום ${window.Config.brand_Name_HE}&phone=${window.Config.whatsAppSelfCare}` : `https://wa.me/${window.Config.whatsAppSelfCare}`}
          target='_blank'
          onClick={handleWhatsappClick}>
          שיחת וואטצפ עם נציג{' '}
        </a>
      </div>

      <div className='icon_call'>
        <Image src={require('./images/icon-58-call@2x.svg')} alt='call' className='icon58call' />
        <a className='context_call' href={isMobile ? `tel:${window.Config.technicalSupportPhone}` : null} onClick={handleServiceClick}>
          {' '}
          חייגו {window.Config.technicalSupportPhone} לנציג שירות
        </a>
      </div>

      <div className='icon_chat'>
        <Image src={require('./images/icon-58-chat@3x.svg')} alt='chat' className='icon58chat' />
        <a className='context_chat' onClick={handleChatClick}>
          צ'ט עם נציג
        </a>
      </div>

      <BtnSubmit isBusiness={false} text='חזרה' onclick={props.closeContactUs} formid='ContactUs' isDisplayArrows={false} />
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {reportDWH};
export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
